import { useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "sonner";
import { CheckIcon } from "lucide-react";

import { LoadboardModal, LoadModalDetails, ModalDisclaimer } from "@/components/dataPages/loadboard";
import { TranslatedText } from "@/components/common/text";
import { API } from "@/services/API";
import { getLoadId } from "@/utils/load";
import { fetchAllOffers } from "@/state/offersSlice";
import { useOffersRefresh } from "@/contexts/OffersRefreshContext";

export const LoadboardBidModal = ({ load, bidAmount, open, onOpenChange, isDisabled, onConfirmBid }) => {
    const dispatch = useDispatch();
    const resetOffersInterval = useOffersRefresh();
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const idToShow = load.externalLoadId || getLoadId(load.uniqueId);

    const handleConfirmQuote = () => {
        if (!isLoading && !load.isUnavailable) {
            setIsLoading(true);
            // Remove commas from the formatted bid amount for API submission
            const rawBidAmount = bidAmount.replace(/,/g, "");
            API.post("/parade/quote", {
                quoteId: load.uniqueId,
                amount: rawBidAmount,
            })
                .then(() => {
                    onOpenChange(false);
                    setError(null);
                    if (resetOffersInterval) {
                        resetOffersInterval();
                    }
                    dispatch(fetchAllOffers({ isAutoRefresh: true }));
                    toast.info(`Load ${idToShow} quoted successfully!\nAwaiting broker response.`);
                    if (onConfirmBid) {
                        onConfirmBid();
                    }
                })
                .catch((err) => {
                    console.error("Failed to quote loads", err);
                    setError(typeof err === "string" ? err : "Quote failed.");
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    };

    return (
        <LoadboardModal
            title="Confirm booking"
            buttonClassName="bg-cm-accent-button text-cm-p-text-primary w-[105px] h-11 disabled:opacity-30 font-medium"
            buttonDisabled={isDisabled}
            buttonChildren={<TranslatedText>Send bid</TranslatedText>}
            open={open}
            onOpenChange={onOpenChange}
        >
            <LoadModalDetails load={load} quote={bidAmount} />
            <ModalDisclaimer text="Disclaimer message to think of if needed to be added here, or instruction what's gonna happen after Confirm." />
            <button
                type="button"
                onClick={handleConfirmQuote}
                disabled={isLoading}
                className="mt-3 bg-cm-accent-button text-cm-p-text-primary w-full h-11 rounded-lg disabled:opacity-30 text-sm/[22px] font-medium inline-flex items-center justify-center gap-1"
            >
                <TranslatedText text="Confirm bid" />
                <CheckIcon className="size-4" />
            </button>
            {error ? <div className="text-cm-error pt-3">{error}</div> : null}
        </LoadboardModal>
    );
};
